import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import ScrollToTop from "./Components/General & MultiUse/ScrollToTop";
import NavLayout from "./Components/General & MultiUse/NavLayout";
import Footer from "./Components/General & MultiUse/Footer";
import Landing from "./Pages/Landing";
import Classes from "./Pages/Classes";
import Register from "./Pages/Register";
import Sponsor from "./Pages/Sponsor";
import ContactUs from "./Pages/Contact";
import Auth from "./Pages/Auth";
import ClassesDetail from "./Components/Classes/ClassesDetail";
import { ZGAProvider } from "./ZGAContext";
import Rules from "./Components/General & MultiUse/Rules";
import Fees from "./Components/General & MultiUse/Fees";
import SuccessFailure from "./Components/General & MultiUse/SuccessFailure";
import Loader from "./Components/General & MultiUse/Loader";
import LoginCheckpoint from "./Components/General & MultiUse/LoginCheckpoint";
import RegisterSuccess from "./Components/General & MultiUse/RegisterSuccess";

function App() {

  return (
    <ZGAProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <NavLayout />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/classes/:classId" element={<ClassesDetail />} />
            <Route path="/register" element={<Register />} />
            <Route path="/sponsor" element={<Sponsor />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/auth/:type" element={<Auth />} />
          </Routes>
          <Footer />
          <Rules />
          <Fees />
          <SuccessFailure />
          <Loader />
          <LoginCheckpoint />
          <RegisterSuccess />
        </BrowserRouter>
      </div>
    </ZGAProvider>
  );
}

export default App;
